import React, { Component } from "react";
import axios from "axios";
import PdfViewer from "../../components/pdf-viewer";
import { endpoint } from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

class SrdViewer extends Component {

    state = {
      keywords: null,
      id: null,
      query: null,
      pdbase64: null,
      pdfUrl: null,
      err: false
    }

  /**
   * Function Return Session ID
   * @returns {Number} Session Id
   */
  getSessionId = () => {
    let sessionId = localStorage.getItem("_sid");
    if (!sessionId) {
      sessionId = sessionStorage.getItem("_sid");
      if (!sessionId) {
        sessionId = "NA";
      }
    }
    return sessionId;
  }

    getQueryParams = () => {
      return decodeURI(window.location.search)
        .replace("?", "")
        .split("&")
        .map(param => param.split("="))
        .reduce((values, [ key, value ]) => {
          values[ key ] = value
          return values
        }, {})
    }

    componentDidMount() {
      const { id, query, term, sourceDisplayName, responseId, url } = this.getQueryParams();

      // backend already gives a directly renderable PDF url, no metadata lookup needed
      if (url) {
        this.setState({ pdfUrl: decodeURIComponent(url) })
        return;
      }

      const sessionId = this.getSessionId();
      if (!id || !query || !term || !sourceDisplayName || !sessionId) {
        this.setState({err: true})
        return;
      }

      clearCookie()

      return axios.post(`${endpoint}/api/search/substances/${id}/metadata?query=${query}&term=${term}&sessionId=${sessionId}`, {
        docId:id,
        action:"document",
        application: "web-browser",
        url:`${endpoint}${this.props.location.pathname}${this.props.location.search}`,
        product:query.trim(),
        searchTerm:term.trim(),
        sourceDisplayName,
        sessionId,
        responseId: +responseId
      }, { withCredentials: false })
        .then(({ data }) => {
          setParentDomainCookie(token, reset, sub, user)
          if (data.highlight.text) {
            const keywords = data.highlight.text;
            const {base64Pdf} = data;
            this.setState(() => {
              return { keywords,
                id,
                query,
                base64Pdf,
                err: false }
            })
          }
        })
        .catch((error) => {
          this.setState(() => {
            return { id,
              query }
          })
        })
    }

    render() {
      const { id, keywords, base64Pdf, pdfUrl } = this.state
      return <React.Fragment>
        {pdfUrl ? <PdfViewer url={pdfUrl} /> : id ? <PdfViewer base64={base64Pdf} keywords={keywords} /> : this.state.err ?
          <div style={{ backgroundColor: "white"}}>Something went wrong.Please contact support.</div> : <div style={{ backgroundColor: "white",
            marginTop: "90px",
            height: "100vh"}}>Loading...</div>}
      </React.Fragment>
    }
}

export default SrdViewer;
